/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ReplaceUiSettingsRequestBody,
  SetUiSettingsRequestBody,
} from '../models/index';
import {
    ReplaceUiSettingsRequestBodyFromJSON,
    ReplaceUiSettingsRequestBodyToJSON,
    SetUiSettingsRequestBodyFromJSON,
    SetUiSettingsRequestBodyToJSON,
} from '../models/index';

export interface ReplaceUiSettingsRequest {
    replaceUiSettingsRequestBody: ReplaceUiSettingsRequestBody;
}

export interface SetUiSettingsRequest {
    setUiSettingsRequestBody: SetUiSettingsRequestBody;
}

/**
 * 
 */
export class AccountUiSettingsResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getUiSettings without sending the request
     */
    async getUiSettingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/account/ui-settings`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUiSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getUiSettingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getUiSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getUiSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for replaceUiSettings without sending the request
     */
    async replaceUiSettingsRequestOpts(requestParameters: ReplaceUiSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['replaceUiSettingsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'replaceUiSettingsRequestBody',
                'Required parameter "replaceUiSettingsRequestBody" was null or undefined when calling replaceUiSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/account/ui-settings`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceUiSettingsRequestBodyToJSON(requestParameters['replaceUiSettingsRequestBody']),
        };
    }

    /**
     */
    async replaceUiSettingsRaw(requestParameters: ReplaceUiSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.replaceUiSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async replaceUiSettings(requestParameters: ReplaceUiSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceUiSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for setUiSettings without sending the request
     */
    async setUiSettingsRequestOpts(requestParameters: SetUiSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['setUiSettingsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'setUiSettingsRequestBody',
                'Required parameter "setUiSettingsRequestBody" was null or undefined when calling setUiSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/account/ui-settings`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUiSettingsRequestBodyToJSON(requestParameters['setUiSettingsRequestBody']),
        };
    }

    /**
     */
    async setUiSettingsRaw(requestParameters: SetUiSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setUiSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setUiSettings(requestParameters: SetUiSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setUiSettingsRaw(requestParameters, initOverrides);
    }

}
